export function getAcrLabel(acr: string | undefined): string {
  switch (acr) {
    case 'urn:qoa.eiam.admin.ch:names:tc:ac:classes:20':
      return 'AuthWeak';
    case 'urn:qoa.eiam.admin.ch:names:tc:ac:classes:30':
      return 'AuthNormal';
    case 'urn:qoa.eiam.admin.ch:names:tc:ac:classes:35':
      return 'AuthNormalExistent';
    case 'urn:qoa.eiam.admin.ch:names:tc:ac:classes:40':
      return 'AuthNormalVerified';
    case 'urn:qoa.eiam.admin.ch:names:tc:ac:classes:50':
      return 'AuthStrong';
    case 'urn:qoa.eiam.admin.ch:names:tc:ac:classes:60':
      return 'AuthVeryStrong';
    default:
      return 'AuthGuest';
  }
}
